import ReactGA from 'react-ga4';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from 'containers/App/App';

ReactGA.initialize('G-1LC4JJGF20');
ReactGA.send({ hitType: 'pageview', page: window.location.pathname + window.location.search });

const container = document.getElementById('app');
const root = createRoot(container);
root.render(<App />);
// #######################################SERVICE WORKER #########
if (process.env.NODE_ENV === 'production') {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js').then(() => { // Removed registration
        // console.log('SW registered'); // Removed console.log
      }).catch(() => { // Removed registrationError
        // console.log('SW registration failed'); // Removed console.log
      });
    });
  }
}

// #######################################/SERVICE WORKER##################################

// TODO theme address bar
// https://developers.google.com/web/tools/lighthouse/audits/address-bar
// https://swizec.com/blog/add-real-web-push-notifications-webapp/swizec/7924
